import { render, staticRenderFns } from "./addSemiOriginal.vue?vue&type=template&id=a104a070&"
import script from "./addSemiOriginal.vue?vue&type=script&lang=js&"
export * from "./addSemiOriginal.vue?vue&type=script&lang=js&"
import style0 from "./addSemiOriginal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports